import React, { useEffect, useState } from 'react';

import {
    Container as MaterialContainer,
    Grid,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer, TitleIcon } from 'common/components';
import * as customColumnsSelectors from 'common/modules/customColumns/selectors';

import createProjectModal from '../createProjectModal';
import * as createProjectModalActions from '../createProjectModal/actions';

import * as actions from './actions';
import Content from './components/Content';
import * as selectors from './selectors';

const Container = ({
    breakpoint,
    contactId = null,
    downloadFile,
    filterProjects,
    handleClickBulkItems,
    handleClickCreate,
    handleSaveRow,
    isFetchingProjects,
    isArchived,
    onlyListView,
    paginationData,
    projects,
    reset,
    showEmptyState,
    tableSettings,
    uploadFile,
}) => {
    const { t } = useTranslation();
    const [filterData, setFilterData] = useState({
        contactId,
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        projectStatus: '',
        searchText: '',
        sortBy: 'desc',
        status: 'active',
    });

    useEffect(() => {
        filterProjects(filterData);
        return () => reset();
    }, [breakpoint]);

    const handlePrepareUpload = (file) => uploadFile(file, filterData);
    const handleOnClickCreate = () => handleClickCreate(contactId);

    return (
        <>
            <MaterialContainer maxWidth={false}>
                <HeaderContainer hidden={onlyListView}>
                    <Grid size="grow">
                        <TitleIcon title={t('Project', { count: 2 })} />
                    </Grid>
                </HeaderContainer>

                <Content
                    contactId={contactId}
                    downloadFile={downloadFile}
                    filterData={filterData}
                    filterProjects={filterProjects}
                    handleClickBulkItems={handleClickBulkItems}
                    handleClickCreate={handleOnClickCreate}
                    handleSaveRow={handleSaveRow}
                    isArchived={isArchived}
                    isFetching={isFetchingProjects}
                    onlyListView={onlyListView}
                    paginationData={paginationData}
                    projects={projects}
                    setFilterData={setFilterData}
                    showEmptyState={showEmptyState}
                    tableSettings={tableSettings}
                    uploadFile={handlePrepareUpload}
                />
            </MaterialContainer>

            <createProjectModal.Container filterData={filterData} />
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    isFetchingProjects: selectors.getIsFetchingProjects,
    paginationData: selectors.getProjectsPagination,
    projects: selectors.getProjectsData,
    showEmptyState: selectors.getShowEmptyState,
    tableSettings: customColumnsSelectors.getTableSettingsData,
});

const mapDispatchToProps = (dispatch) => ({
    filterProjects: (filterData) =>
        dispatch(actions.filterProjects(filterData)),
    handleClickBulkItems: (ids, value, filterData) =>
        dispatch(actions.prepareBulkItems(ids, value, filterData)),
    handleClickCreate: (contactId) =>
        dispatch(createProjectModalActions.prepareCreate(contactId)),
    handleSaveRow: (item) => dispatch(actions.updateProduct(item)),
    reset: () => dispatch(actions.reset()),
});

Container.propTypes = {
    breakpoint: PropTypes.string,
    contactId: PropTypes.string,
    downloadFile: PropTypes.func,
    filterProjects: PropTypes.func,
    handleClickBulkItems: PropTypes.func,
    handleClickCreate: PropTypes.func,
    handleSaveRow: PropTypes.func,
    isFetchingProjects: PropTypes.bool,
    isArchived: PropTypes.bool,
    onlyListView: PropTypes.bool,
    paginationData: PropTypes.object,
    projects: PropTypes.array,
    reset: PropTypes.func,
    showEmptyState: PropTypes.object,
    tableSettings: PropTypes.array,
    uploadFile: PropTypes.func,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Container));
